import { isAxiosError } from 'axios';

/**
 * Ekstraherer feilmelding fra error-objekt
 * Håndterer ProblemDetails, PrimaryTypeChangeResponse og generiske feil
 */
export function extractErrorMessage (error: unknown): string {
  // Håndter ikke-Axios feil
  if (!isAxiosError(error)) {
    return error instanceof Error ? error.message : 'Feil ved lagring';
  }

  const responseData = error.response?.data;
  if (!responseData || typeof responseData !== 'object') {
    return 'Feil ved lagring';
  }

  // PrimaryTypeChangeResponse
  if ('warningMessage' in responseData && typeof responseData.warningMessage === 'string') {
    return responseData.warningMessage;
  }

  // ProblemDetails
  if ('type' in responseData && 'title' in responseData) {
    // Håndter valideringsfeil (errors-objekt)
    if ('errors' in responseData && typeof responseData.errors === 'object' && responseData.errors !== null) {
      const errorMessages = Object.values(responseData.errors)
        .flat()
        .filter((msg): msg is string => false);

      if (errorMessages.length > 0) {
        return errorMessages.join('. ');
      }
    }

    // Fallback til detail eller title
    return (responseData.detail || responseData.title || 'Feil ved lagring') as string;
  }

  return 'Feil ved lagring';
}

